export const colors = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'EF', 'GH', 'IJ', 'JK'];
export const clarities = ['IF', 'VVS1', 'VVS2', 'VVS', 'VS1', 'VS2', 'VS', 'SI1', 'SI2', 'SI', 'I'];
export const sieveSizes = ['-2', '1-5', '6,7', '8', '9', '10-13', '14-17', '20'];
export const solitaireSizes = [0.2,0.25,0.3,0.5];
export const metalPurity = ['18', '14'];
export const metalTypes = ['Gold', 'Silver', 'Platinum'];
export const metalColors = ['yellow gold', 'white gold', 'rose gold'];
export const diamonShapes = ['Round', 'Princess', 'Emerald', 'Asscher', 'Cushion', 'Marquise', 'Pear', 'Heart'];
export const settingTypes = ['Solitaire', 'Halo', 'Three Stone', 'Pavé', 'Channel', 'Bezel', 'Tension', 'Cluster'];

export const categoryOptions = [
    "Rings", "Earrings", "Necklaces", "Bracelets", "Bangles", "Pendants", "Chains", "Nosepins", "Anklets", "Mangalsutra"
  ];
  
export const subCategoryOptions = [
    "Stud Earrings", "Hoop Earrings", "Drop Earrings", "Solitaire Rings", "Band Rings", "Pendant Sets",
    "Gold Chains", "Beaded Chains", "Nose Rings", "Cuff Bracelets", "Charm Bracelets", "Kada", "Bangle Set"
  ];

export const occasionOptions = [
    "Casual", "Formal", "Daily Wear", "Wedding", "Engagement", "Anniversary", "Festive", "Party", "Gift"
  ];
  
export const tagsOptions = [
    "Traditional", "Contemporary", "Minimalist", "Classic", "Statement", "Vintage", "Boho", "Geometric"
  ];

  export const diamondCertificationOptions = [
    "GIA",
    "IGI",
    "HRD",
    "AGS",
    "SGL",
    "EGL",
    "PGI",
    "BIS",
    "NGTC",
    "GCAL"
  ];

enum OfferComponent {
  MAKING = "MAKING_CHARGES",
  DIAMONDS = "DIAMONDS",
  SOLITAIRES = "SOLITAIRES",
  GEMSTONES = "GEMSTONES",
  GOLD = "GOLD",
  PLATINUM = "PLATINUM",
}

export const OfferComponentOptions = Object.values(OfferComponent);
